import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { BasePage, PageType } from 'src/components/BasePage';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { SettingsLicenseStore } from 'src/stores/SettingsStores/SettingsLicenseStore/SettingsLicenseStore';
import { CombinedLoadingStatus } from 'src/utils/mobx/CombinedLoadingStatus';

export const LicenseKeyDetails = observer(() => {
    useEffect(() => {
        store.loadItem('');
        store.loadForm(store.itemDetailsFormKey);
        store.updateItemLoader.reset();

        return () => {
            store.itemLoader.reset();
            store.formLoader.reset();
            store.updateItemLoader.reset();
        };
    }, []);

    const loadingStatus = useMemo(() => {
        return new CombinedLoadingStatus([
            store.formLoader,
            store.itemLoader,
            store.updateItemLoader,
        ]);
    }, []);

    const licenseInfo = useMemo(() => {
        return store.updateItemLoader.data || store.currentItem;
    }, [store.currentItem, store.updateItemLoader.data]);

    if (loadingStatus.isLoading) {
        return <SpinnerFullWidth />;
    }

    return (
        <BasePage
            pageName="application-license"
            type={PageType.FULL}
            data-testid="settings-application-license"
        >
            <FormioForm
                form={store.currentItemForm!}
                submission={{ data: licenseInfo }}
                normalizeSubmission
                onSubmit={async (submission) => {
                    await store.update('', submission.data);
                }}
            />
        </BasePage>
    );
});

const store = SettingsLicenseStore;
